export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

export async function generateUserIdFromEmail(email: string): Promise<string> {
  // Normalize email to lowercase for consistency
  const normalizedEmail = email.toLowerCase().trim();

  // Use Web Crypto API to create a hash
  const encoder = new TextEncoder();
  const data = encoder.encode(normalizedEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  // Take first 12 characters for a shorter ID while maintaining uniqueness
  return `user_${hashHex.substring(0, 12)}`;
}

export async function generateThreadSlugFromEmail(email: string): Promise<string> {
  // Normalize email to lowercase for consistency
  const normalizedEmail = email.toLowerCase().trim();

  // Use Web Crypto API to create a hash
  const encoder = new TextEncoder();
  const data = encoder.encode(normalizedEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  // Take characters 12-24 for thread slug (different from userId to avoid collisions)
  return `thread_${hashHex.substring(12, 24)}`;
}

export async function generateUserIdFromName(name: string): Promise<string> {
  // Normalize name for consistency
  const normalizedName = name.toLowerCase().trim();

  // Use Web Crypto API to create a hash
  const encoder = new TextEncoder();
  const data = encoder.encode(normalizedName);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  // Take first 12 characters for a shorter ID while maintaining uniqueness
  return `user_${hashHex.substring(0, 12)}`;
}
